const points = [
  {
    icon: 'ri-robot-line',
    side: 'ai',
    title: 'ИИ анализирует данные',
    text: 'Мгновенный сбор семантики и анализ сотен конкурентов для создания идеальной структуры.',
  },
  {
    icon: 'ri-user-smile-line',
    side: 'human',
    title: 'Эксперт «очеловечивает» контент',
    text: 'Наш копирайтер лично редактирует каждый текст, добавляя реальные кейсы, ваш уникальный Tone of Voice и проверку фактов.',
  },
  {
    icon: 'ri-shield-flash-line',
    side: 'ai',
    title: 'Защита от санкций',
    text: 'Ручная доработка гарантирует отсутствие «роботизированности» и защищает сайт от теневых банов поисковиков.',
  },
];

export default function SEOArticleAI() {
  return (
    <section id="seo-ai-tandem" className="py-12 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Left: text */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#C5A880]/15 border border-[#C5A880]/30 mb-5">
              <i className="ri-team-line text-[#C5A880] text-sm"></i>
              <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
                Тандем человека и ИИ
              </span>
            </div>
            <h2 className="text-2xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
              ИИ — наш мощный помощник,{' '}
              <span className="block sm:inline">а не замена автору.</span>
            </h2>
            <div className="w-14 h-1 bg-[#C5A880] mb-5 rounded-full"></div>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed font-['Montserrat'] mb-6 text-justify">
              Мы используем передовой AI-SEO подход, чтобы вы получали результат быстрее и выгоднее:
            </p>

            <div className="space-y-3 sm:space-y-4">
              {points.map((p, i) => (
                <div key={i} className="flex items-start gap-3 sm:gap-4 bg-[#F8F9FA] rounded-2xl p-4 sm:p-5 border border-gray-100">
                  <div className={`flex-shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-xl flex items-center justify-center ${p.side === 'ai' ? 'bg-[#1A2B4C]' : 'bg-[#C5A880]'}`}>
                    <i className={`${p.icon} text-base sm:text-lg text-white`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-[#1A2B4C] mb-1 font-['Montserrat']">
                      {p.title}
                    </h4>
                    <p className="text-xs sm:text-sm text-gray-600 leading-relaxed font-['Montserrat'] text-justify">
                      {p.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: visual */}
          <div className="relative mt-4 lg:mt-0">
            <img
              src="https://public.readdy.ai/ai/img_res/c903356e00dcc5c92ae60005ebcb5832.jpg"
              alt="Тандем ИИ и эксперта"
              className="w-full h-64 sm:h-80 lg:h-96 object-cover object-top rounded-2xl sm:rounded-3xl"
            />
            {/* Badge overlay */}
            <div className="absolute bottom-4 left-4 right-4 bg-[#1A2B4C]/90 backdrop-blur-md rounded-xl sm:rounded-2xl p-3 sm:p-4 border border-white/10">
              <div className="grid grid-cols-3 gap-2">
                <div className="text-center">
                  <div className="text-[#C5A880] text-base sm:text-xl font-bold font-['Playfair_Display']">&lt; 9%</div>
                  <div className="text-white/60 text-xs font-['Montserrat'] leading-tight">Плотность ключей</div>
                </div>
                <div className="text-center border-x border-white/20">
                  <div className="text-[#C5A880] text-base sm:text-xl font-bold font-['Playfair_Display']">&gt; 90%</div>
                  <div className="text-white/60 text-xs font-['Montserrat'] leading-tight">Уникальность</div>
                </div>
                <div className="text-center">
                  <div className="text-[#C5A880] text-base sm:text-xl font-bold font-['Playfair_Display']">24/7</div>
                  <div className="text-white/60 text-xs font-['Montserrat'] leading-tight">Работа статьи</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
